import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _64018866 = () => interopDefault(import('../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _3f56db80 = () => interopDefault(import('../../pages/account/profile/index.vue' /* webpackChunkName: "pages/account/profile/index" */))
const _2d892b0e = () => interopDefault(import('../../pages/account/teacher/index.vue' /* webpackChunkName: "pages/account/teacher/index" */))
const _12195a00 = () => interopDefault(import('../../pages/activity/diary/index.vue' /* webpackChunkName: "pages/activity/diary/index" */))
const _630e56d7 = () => interopDefault(import('../../pages/activity/services/index.vue' /* webpackChunkName: "pages/activity/services/index" */))
const _096eb746 = () => interopDefault(import('../../pages/activity/sessions-history/index.vue' /* webpackChunkName: "pages/activity/sessions-history/index" */))
const _9acac742 = () => interopDefault(import('../../pages/activity/sessions-to-come/index.vue' /* webpackChunkName: "pages/activity/sessions-to-come/index" */))
const _46a477bf = () => interopDefault(import('../../pages/center/places/index.vue' /* webpackChunkName: "pages/center/places/index" */))
const _781c72e0 = () => interopDefault(import('../../pages/center/team/index.vue' /* webpackChunkName: "pages/center/team/index" */))
const _2ec0dd24 = () => interopDefault(import('../../pages/dashboard/activity.vue' /* webpackChunkName: "pages/dashboard/activity" */))
const _133b8bc8 = () => interopDefault(import('../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _33c8bcab = () => interopDefault(import('../../pages/finance/desk/index.vue' /* webpackChunkName: "pages/finance/desk/index" */))
const _4e4fa6bc = () => interopDefault(import('../../pages/finance/ewallet/index.vue' /* webpackChunkName: "pages/finance/ewallet/index" */))
const _05c510d8 = () => interopDefault(import('../../pages/finance/iban/index.vue' /* webpackChunkName: "pages/finance/iban/index" */))
const _4812a235 = () => interopDefault(import('../../pages/finance/settings/index.vue' /* webpackChunkName: "pages/finance/settings/index" */))
const _0e41fb8c = () => interopDefault(import('../../pages/finance/subscriptions/index.vue' /* webpackChunkName: "pages/finance/subscriptions/index" */))
const _4695a565 = () => interopDefault(import('../../pages/marketing/my_blog/index.vue' /* webpackChunkName: "pages/marketing/my_blog/index" */))
const _7775caca = () => interopDefault(import('../../pages/marketing/my_site/index.vue' /* webpackChunkName: "pages/marketing/my_site/index" */))
const _fcfa7fe0 = () => interopDefault(import('../../pages/account/teacher/profile.vue' /* webpackChunkName: "pages/account/teacher/profile" */))
const _f2501036 = () => interopDefault(import('../../pages/activity/services/new.vue' /* webpackChunkName: "pages/activity/services/new" */))
const _2971fe1d = () => interopDefault(import('../../pages/center/places/add_favorite.vue' /* webpackChunkName: "pages/center/places/add_favorite" */))
const _785d9a66 = () => interopDefault(import('../../pages/center/places/new.vue' /* webpackChunkName: "pages/center/places/new" */))
const _51031a82 = () => interopDefault(import('../../pages/center/team/add_teacher.vue' /* webpackChunkName: "pages/center/team/add_teacher" */))
const _5918616a = () => interopDefault(import('../../pages/dashboard/seo/global.vue' /* webpackChunkName: "pages/dashboard/seo/global" */))
const _1544dc1a = () => interopDefault(import('../../pages/marketing/my_blog/new.vue' /* webpackChunkName: "pages/marketing/my_blog/new" */))
const _2d8c096e = () => interopDefault(import('../../pages/marketing/my_site/new_booking_module.vue' /* webpackChunkName: "pages/marketing/my_site/new_booking_module" */))
const _6c27edbe = () => interopDefault(import('../../pages/marketing/my_site/new_site.vue' /* webpackChunkName: "pages/marketing/my_site/new_site" */))
const _031d847f = () => interopDefault(import('../../pages/activity/services/_serviceId/index.vue' /* webpackChunkName: "pages/activity/services/_serviceId/index" */))
const _055acccc = () => interopDefault(import('../../pages/activity/sessions-history/_sessionId/index.vue' /* webpackChunkName: "pages/activity/sessions-history/_sessionId/index" */))
const _60f8ec58 = () => interopDefault(import('../../pages/activity/sessions-to-come/_sessionId/index.vue' /* webpackChunkName: "pages/activity/sessions-to-come/_sessionId/index" */))
const _7f1dffb1 = () => interopDefault(import('../../pages/activity/video-waiting-room/_sessionId/index.vue' /* webpackChunkName: "pages/activity/video-waiting-room/_sessionId/index" */))
const _b10c2d42 = () => interopDefault(import('../../pages/activity/video/_sessionId/index.vue' /* webpackChunkName: "pages/activity/video/_sessionId/index" */))
const _9fc94432 = () => interopDefault(import('../../pages/center/places/_id.vue' /* webpackChunkName: "pages/center/places/_id" */))
const _69d96992 = () => interopDefault(import('../../pages/marketing/my_blog/_blogId/index.vue' /* webpackChunkName: "pages/marketing/my_blog/_blogId/index" */))
const _d19e8bc8 = () => interopDefault(import('../../pages/marketing/my_site/_siteId/index.vue' /* webpackChunkName: "pages/marketing/my_site/_siteId/index" */))
const _ed66b59a = () => interopDefault(import('../../pages/account/teacher/_discipline/edit.vue' /* webpackChunkName: "pages/account/teacher/_discipline/edit" */))
const _4ea7e7b4 = () => interopDefault(import('../../pages/activity/services/_serviceId/plannings/index.vue' /* webpackChunkName: "pages/activity/services/_serviceId/plannings/index" */))
const _5ea11de4 = () => interopDefault(import('../../pages/activity/services/_serviceId/plannings/_planningId/index.vue' /* webpackChunkName: "pages/activity/services/_serviceId/plannings/_planningId/index" */))
const _14b0b17c = () => interopDefault(import('../../pages/activity/services/_serviceId/plannings/_planningId/payment.vue' /* webpackChunkName: "pages/activity/services/_serviceId/plannings/_planningId/payment" */))
const _44eeab97 = () => interopDefault(import('../../pages/activity/sessions-history/_sessionId/_participantId.vue' /* webpackChunkName: "pages/activity/sessions-history/_sessionId/_participantId" */))
const _36de50b6 = () => interopDefault(import('../../pages/center/_center_id.vue' /* webpackChunkName: "pages/center/_center_id" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/admin/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _64018866,
    name: "account___fr___default"
  }, {
    path: "/account/profile",
    component: _3f56db80,
    name: "account-profile___fr___default"
  }, {
    path: "/account/teacher",
    component: _2d892b0e,
    name: "account-teacher___fr___default"
  }, {
    path: "/activity/diary",
    component: _12195a00,
    name: "activity-diary___fr___default"
  }, {
    path: "/activity/services",
    component: _630e56d7,
    name: "activity-services___fr___default"
  }, {
    path: "/activity/sessions-history",
    component: _096eb746,
    name: "activity-sessions-history___fr___default"
  }, {
    path: "/activity/sessions-to-come",
    component: _9acac742,
    name: "activity-sessions-to-come___fr___default"
  }, {
    path: "/center/places",
    component: _46a477bf,
    name: "center-places___fr___default"
  }, {
    path: "/center/team",
    component: _781c72e0,
    name: "center-team___fr___default"
  }, {
    path: "/dashboard/activity",
    component: _2ec0dd24,
    name: "dashboard-activity___fr___default"
  }, {
    path: "/en/",
    component: _133b8bc8,
    name: "index___en"
  }, {
    path: "/en/account",
    component: _64018866,
    name: "account___en"
  }, {
    path: "/finance/desk",
    component: _33c8bcab,
    name: "finance-desk___fr___default"
  }, {
    path: "/finance/ewallet",
    component: _4e4fa6bc,
    name: "finance-ewallet___fr___default"
  }, {
    path: "/finance/iban",
    component: _05c510d8,
    name: "finance-iban___fr___default"
  }, {
    path: "/finance/settings",
    component: _4812a235,
    name: "finance-settings___fr___default"
  }, {
    path: "/finance/subscriptions",
    component: _0e41fb8c,
    name: "finance-subscriptions___fr___default"
  }, {
    path: "/fr/",
    component: _133b8bc8,
    name: "index___fr"
  }, {
    path: "/fr/account",
    component: _64018866,
    name: "account___fr"
  }, {
    path: "/marketing/my_blog",
    component: _4695a565,
    name: "marketing-my_blog___fr___default"
  }, {
    path: "/marketing/my_site",
    component: _7775caca,
    name: "marketing-my_site___fr___default"
  }, {
    path: "/account/teacher/profile",
    component: _fcfa7fe0,
    name: "account-teacher-profile___fr___default"
  }, {
    path: "/activity/services/new",
    component: _f2501036,
    name: "activity-services-new___fr___default"
  }, {
    path: "/center/places/add_favorite",
    component: _2971fe1d,
    name: "center-places-add_favorite___fr___default"
  }, {
    path: "/center/places/new",
    component: _785d9a66,
    name: "center-places-new___fr___default"
  }, {
    path: "/center/team/add_teacher",
    component: _51031a82,
    name: "center-team-add_teacher___fr___default"
  }, {
    path: "/dashboard/seo/global",
    component: _5918616a,
    name: "dashboard-seo-global___fr___default"
  }, {
    path: "/en/account/profile",
    component: _3f56db80,
    name: "account-profile___en"
  }, {
    path: "/en/account/teacher",
    component: _2d892b0e,
    name: "account-teacher___en"
  }, {
    path: "/en/activity/diary",
    component: _12195a00,
    name: "activity-diary___en"
  }, {
    path: "/en/activity/services",
    component: _630e56d7,
    name: "activity-services___en"
  }, {
    path: "/en/activity/sessions-history",
    component: _096eb746,
    name: "activity-sessions-history___en"
  }, {
    path: "/en/activity/sessions-to-come",
    component: _9acac742,
    name: "activity-sessions-to-come___en"
  }, {
    path: "/en/center/places",
    component: _46a477bf,
    name: "center-places___en"
  }, {
    path: "/en/center/team",
    component: _781c72e0,
    name: "center-team___en"
  }, {
    path: "/en/dashboard/activity",
    component: _2ec0dd24,
    name: "dashboard-activity___en"
  }, {
    path: "/en/finance/desk",
    component: _33c8bcab,
    name: "finance-desk___en"
  }, {
    path: "/en/finance/ewallet",
    component: _4e4fa6bc,
    name: "finance-ewallet___en"
  }, {
    path: "/en/finance/iban",
    component: _05c510d8,
    name: "finance-iban___en"
  }, {
    path: "/en/finance/settings",
    component: _4812a235,
    name: "finance-settings___en"
  }, {
    path: "/en/finance/subscriptions",
    component: _0e41fb8c,
    name: "finance-subscriptions___en"
  }, {
    path: "/en/marketing/my_blog",
    component: _4695a565,
    name: "marketing-my_blog___en"
  }, {
    path: "/en/marketing/my_site",
    component: _7775caca,
    name: "marketing-my_site___en"
  }, {
    path: "/fr/account/profile",
    component: _3f56db80,
    name: "account-profile___fr"
  }, {
    path: "/fr/account/teacher",
    component: _2d892b0e,
    name: "account-teacher___fr"
  }, {
    path: "/fr/activity/diary",
    component: _12195a00,
    name: "activity-diary___fr"
  }, {
    path: "/fr/activity/services",
    component: _630e56d7,
    name: "activity-services___fr"
  }, {
    path: "/fr/activity/sessions-history",
    component: _096eb746,
    name: "activity-sessions-history___fr"
  }, {
    path: "/fr/activity/sessions-to-come",
    component: _9acac742,
    name: "activity-sessions-to-come___fr"
  }, {
    path: "/fr/center/places",
    component: _46a477bf,
    name: "center-places___fr"
  }, {
    path: "/fr/center/team",
    component: _781c72e0,
    name: "center-team___fr"
  }, {
    path: "/fr/dashboard/activity",
    component: _2ec0dd24,
    name: "dashboard-activity___fr"
  }, {
    path: "/fr/finance/desk",
    component: _33c8bcab,
    name: "finance-desk___fr"
  }, {
    path: "/fr/finance/ewallet",
    component: _4e4fa6bc,
    name: "finance-ewallet___fr"
  }, {
    path: "/fr/finance/iban",
    component: _05c510d8,
    name: "finance-iban___fr"
  }, {
    path: "/fr/finance/settings",
    component: _4812a235,
    name: "finance-settings___fr"
  }, {
    path: "/fr/finance/subscriptions",
    component: _0e41fb8c,
    name: "finance-subscriptions___fr"
  }, {
    path: "/fr/marketing/my_blog",
    component: _4695a565,
    name: "marketing-my_blog___fr"
  }, {
    path: "/fr/marketing/my_site",
    component: _7775caca,
    name: "marketing-my_site___fr"
  }, {
    path: "/marketing/my_blog/new",
    component: _1544dc1a,
    name: "marketing-my_blog-new___fr___default"
  }, {
    path: "/marketing/my_site/new_booking_module",
    component: _2d8c096e,
    name: "marketing-my_site-new_booking_module___fr___default"
  }, {
    path: "/marketing/my_site/new_site",
    component: _6c27edbe,
    name: "marketing-my_site-new_site___fr___default"
  }, {
    path: "/en/account/teacher/profile",
    component: _fcfa7fe0,
    name: "account-teacher-profile___en"
  }, {
    path: "/en/activity/services/new",
    component: _f2501036,
    name: "activity-services-new___en"
  }, {
    path: "/en/center/places/add_favorite",
    component: _2971fe1d,
    name: "center-places-add_favorite___en"
  }, {
    path: "/en/center/places/new",
    component: _785d9a66,
    name: "center-places-new___en"
  }, {
    path: "/en/center/team/add_teacher",
    component: _51031a82,
    name: "center-team-add_teacher___en"
  }, {
    path: "/en/dashboard/seo/global",
    component: _5918616a,
    name: "dashboard-seo-global___en"
  }, {
    path: "/en/marketing/my_blog/new",
    component: _1544dc1a,
    name: "marketing-my_blog-new___en"
  }, {
    path: "/en/marketing/my_site/new_booking_module",
    component: _2d8c096e,
    name: "marketing-my_site-new_booking_module___en"
  }, {
    path: "/en/marketing/my_site/new_site",
    component: _6c27edbe,
    name: "marketing-my_site-new_site___en"
  }, {
    path: "/fr/account/teacher/profile",
    component: _fcfa7fe0,
    name: "account-teacher-profile___fr"
  }, {
    path: "/fr/activity/services/new",
    component: _f2501036,
    name: "activity-services-new___fr"
  }, {
    path: "/fr/center/places/add_favorite",
    component: _2971fe1d,
    name: "center-places-add_favorite___fr"
  }, {
    path: "/fr/center/places/new",
    component: _785d9a66,
    name: "center-places-new___fr"
  }, {
    path: "/fr/center/team/add_teacher",
    component: _51031a82,
    name: "center-team-add_teacher___fr"
  }, {
    path: "/fr/dashboard/seo/global",
    component: _5918616a,
    name: "dashboard-seo-global___fr"
  }, {
    path: "/fr/marketing/my_blog/new",
    component: _1544dc1a,
    name: "marketing-my_blog-new___fr"
  }, {
    path: "/fr/marketing/my_site/new_booking_module",
    component: _2d8c096e,
    name: "marketing-my_site-new_booking_module___fr"
  }, {
    path: "/fr/marketing/my_site/new_site",
    component: _6c27edbe,
    name: "marketing-my_site-new_site___fr"
  }, {
    path: "/en/activity/services/:serviceId",
    component: _031d847f,
    name: "activity-services-serviceId___en"
  }, {
    path: "/en/activity/sessions-history/:sessionId",
    component: _055acccc,
    name: "activity-sessions-history-sessionId___en"
  }, {
    path: "/en/activity/sessions-to-come/:sessionId",
    component: _60f8ec58,
    name: "activity-sessions-to-come-sessionId___en"
  }, {
    path: "/en/activity/video-waiting-room/:sessionId",
    component: _7f1dffb1,
    name: "activity-video-waiting-room-sessionId___en"
  }, {
    path: "/en/activity/video/:sessionId",
    component: _b10c2d42,
    name: "activity-video-sessionId___en"
  }, {
    path: "/en/center/places/:id",
    component: _9fc94432,
    name: "center-places-id___en"
  }, {
    path: "/en/marketing/my_blog/:blogId",
    component: _69d96992,
    name: "marketing-my_blog-blogId___en"
  }, {
    path: "/en/marketing/my_site/:siteId",
    component: _d19e8bc8,
    name: "marketing-my_site-siteId___en"
  }, {
    path: "/fr/activity/services/:serviceId",
    component: _031d847f,
    name: "activity-services-serviceId___fr"
  }, {
    path: "/fr/activity/sessions-history/:sessionId",
    component: _055acccc,
    name: "activity-sessions-history-sessionId___fr"
  }, {
    path: "/fr/activity/sessions-to-come/:sessionId",
    component: _60f8ec58,
    name: "activity-sessions-to-come-sessionId___fr"
  }, {
    path: "/fr/activity/video-waiting-room/:sessionId",
    component: _7f1dffb1,
    name: "activity-video-waiting-room-sessionId___fr"
  }, {
    path: "/fr/activity/video/:sessionId",
    component: _b10c2d42,
    name: "activity-video-sessionId___fr"
  }, {
    path: "/fr/center/places/:id",
    component: _9fc94432,
    name: "center-places-id___fr"
  }, {
    path: "/fr/marketing/my_blog/:blogId",
    component: _69d96992,
    name: "marketing-my_blog-blogId___fr"
  }, {
    path: "/fr/marketing/my_site/:siteId",
    component: _d19e8bc8,
    name: "marketing-my_site-siteId___fr"
  }, {
    path: "/en/account/teacher/:discipline/edit",
    component: _ed66b59a,
    name: "account-teacher-discipline-edit___en"
  }, {
    path: "/en/activity/services/:serviceId/plannings",
    component: _4ea7e7b4,
    name: "activity-services-serviceId-plannings___en"
  }, {
    path: "/fr/account/teacher/:discipline/edit",
    component: _ed66b59a,
    name: "account-teacher-discipline-edit___fr"
  }, {
    path: "/fr/activity/services/:serviceId/plannings",
    component: _4ea7e7b4,
    name: "activity-services-serviceId-plannings___fr"
  }, {
    path: "/en/activity/services/:serviceId/plannings/:planningId",
    component: _5ea11de4,
    name: "activity-services-serviceId-plannings-planningId___en"
  }, {
    path: "/fr/activity/services/:serviceId/plannings/:planningId",
    component: _5ea11de4,
    name: "activity-services-serviceId-plannings-planningId___fr"
  }, {
    path: "/en/activity/services/:serviceId/plannings/:planningId/payment",
    component: _14b0b17c,
    name: "activity-services-serviceId-plannings-planningId-payment___en"
  }, {
    path: "/fr/activity/services/:serviceId/plannings/:planningId/payment",
    component: _14b0b17c,
    name: "activity-services-serviceId-plannings-planningId-payment___fr"
  }, {
    path: "/en/activity/sessions-history/:sessionId?/:participantId",
    component: _44eeab97,
    name: "activity-sessions-history-sessionId-participantId___en"
  }, {
    path: "/fr/activity/sessions-history/:sessionId?/:participantId",
    component: _44eeab97,
    name: "activity-sessions-history-sessionId-participantId___fr"
  }, {
    path: "/activity/services/:serviceId",
    component: _031d847f,
    name: "activity-services-serviceId___fr___default"
  }, {
    path: "/activity/sessions-history/:sessionId",
    component: _055acccc,
    name: "activity-sessions-history-sessionId___fr___default"
  }, {
    path: "/activity/sessions-to-come/:sessionId",
    component: _60f8ec58,
    name: "activity-sessions-to-come-sessionId___fr___default"
  }, {
    path: "/activity/video-waiting-room/:sessionId",
    component: _7f1dffb1,
    name: "activity-video-waiting-room-sessionId___fr___default"
  }, {
    path: "/activity/video/:sessionId",
    component: _b10c2d42,
    name: "activity-video-sessionId___fr___default"
  }, {
    path: "/center/places/:id",
    component: _9fc94432,
    name: "center-places-id___fr___default"
  }, {
    path: "/en/center/:center_id?",
    component: _36de50b6,
    name: "center-center_id___en"
  }, {
    path: "/fr/center/:center_id?",
    component: _36de50b6,
    name: "center-center_id___fr"
  }, {
    path: "/marketing/my_blog/:blogId",
    component: _69d96992,
    name: "marketing-my_blog-blogId___fr___default"
  }, {
    path: "/marketing/my_site/:siteId",
    component: _d19e8bc8,
    name: "marketing-my_site-siteId___fr___default"
  }, {
    path: "/account/teacher/:discipline/edit",
    component: _ed66b59a,
    name: "account-teacher-discipline-edit___fr___default"
  }, {
    path: "/activity/services/:serviceId/plannings",
    component: _4ea7e7b4,
    name: "activity-services-serviceId-plannings___fr___default"
  }, {
    path: "/activity/services/:serviceId/plannings/:planningId",
    component: _5ea11de4,
    name: "activity-services-serviceId-plannings-planningId___fr___default"
  }, {
    path: "/activity/services/:serviceId/plannings/:planningId/payment",
    component: _14b0b17c,
    name: "activity-services-serviceId-plannings-planningId-payment___fr___default"
  }, {
    path: "/activity/sessions-history/:sessionId?/:participantId",
    component: _44eeab97,
    name: "activity-sessions-history-sessionId-participantId___fr___default"
  }, {
    path: "/center/:center_id?",
    component: _36de50b6,
    name: "center-center_id___fr___default"
  }, {
    path: "/",
    component: _133b8bc8,
    name: "index___fr___default"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
